import { getStoredToken } from '../auth'

import type { MetadataResponse } from './metadata.types'

const API_BASE_URL = import.meta.env.VITE_DAPI_URL || ''

const getAuthorizationHeader = () => {
  const token = getStoredToken()

  if (!token || !('jwt' in token) || !token.jwt) {
    throw new Error('Missing authentication token.')
  }

  return { authorization: `bearer ${token.jwt}` }
}

export const fetchMetadata = async (): Promise<MetadataResponse> => {
  if (!API_BASE_URL) {
    throw new Error('Missing API base URL (VITE_DAPI_URL).')
  }

  const response = await fetch(`${API_BASE_URL}/borgo/distributor/metadata`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'content-type': 'application/json',
      ...getAuthorizationHeader(),
    },
  })

  if (!response.ok) {
    throw new Error(`Failed to fetch metadata (${response.status})`)
  }

  return (await response.json()) as MetadataResponse
}
